// extracted by mini-css-extract-plugin
export default {"Form":"BookForm_Form__zi+ak","Stars":"BookForm_Stars__3zq17","AddImage":"BookForm_AddImage__nQc6j"};